// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__CAqfu","message":"NotFoundPage_message__4RyfM"};